
import frag from 'vue-frag';
import { CAMPAIGN_BUTTON_TIMER } from '~/constants/global';
import TimerIcon from '~/static/timer.svg';
import ShopExclusivesIcon from '~/static/shop-exclusives.svg';
import EmailLoveIcon from '~/static/email-love.svg';
import AppsumoPlusIcon from '~/static/as-plus.svg';

export default {
  directives: { frag },
  data() {
    return {
      TimerIcon,
      ShopExclusivesIcon,
      EmailLoveIcon,
      AppsumoPlusIcon,
      now: new Date(),
    };
  },
  computed: {
    isCampaignExperiment() {
      return this.$store.state.experiments.campaignButton;
    },
    image() {
      return this.campaign?.image || TimerIcon;
    },
    label() {
      return this.campaign?.label;
    },
    link() {
      return `${this.campaign?.link}?ref=nav_countdown`;
    },
    campaign() {
      const { button } = this.$store.state.session?.session;

      return button;
    },
    timeRemaining() {
      let seconds = Math.floor((this.endDate - this.now) / 1000);

      if (seconds > 0) {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor(seconds / 60) % 60;
        seconds %= 60;

        const parts = [];
        if (hours) {
          parts.push(String(hours).padStart(2, '0'));
        }

        parts.push(String(mins).padStart(2, '0'));

        if (hours || mins || seconds) {
          parts.push(String(seconds).padStart(2, '0'));
        }

        return parts.join(':');
      }

      return '00:00';
    },
    hasTimer() {
      if (this.isCampaign && !this.isEnded) {
        const now = new Date();
        const untilStart = this.endDate - now;

        return (untilStart > -1 && untilStart < CAMPAIGN_BUTTON_TIMER);
      }

      return false;
    },
    isEnded() {
      const now = new Date();
      return now > this.endDate;
    },
    isCampaign() {
      return (this.isCampaignExperiment && this.campaign && !this.isEnded);
    },
    endDate() {
      return this.campaign?.end_date ? new Date(this.campaign.end_date) : null;
    },
  },
  watch: {
    isCampaignExperiment() {
      this.startCampaignTimer();
    },
  },
  mounted() {
    this.startCampaignTimer();
  },
  beforeUnmount() {
    if (this.processId) {
      window.clearInterval(this.processId);
    }
  },
  methods: {
    startCampaignTimer() {
      this.processId = !this.processId && this.isCampaign && !this.isEnded
        && typeof window !== 'undefined' && window.setInterval(this.updateCampaignTimer, 1000);
    },
    updateCampaignTimer() {
      this.now = new Date();

      // campaign has ended so stop timer
      if (this.isEnded) {
        window.clearInterval(this.processId);
        this.processId = null;
      }
    },
  },
};
